export const NOT_VALID_INVITATION =
  'The invitation is not valid or has expired';
